import { render, staticRenderFns } from "./ToggleRadioCardListSection.vue?vue&type=template&id=23a1112c&scoped=true"
import script from "./ToggleRadioCardListSection.vue?vue&type=script&lang=ts"
export * from "./ToggleRadioCardListSection.vue?vue&type=script&lang=ts"
import style0 from "./ToggleRadioCardListSection.vue?vue&type=style&index=0&id=23a1112c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a1112c",
  null
  
)

export default component.exports